import {
  Input,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import React from "react";
import { LEASE } from "../../utilities/constants.js";
import TableStyleUtility from "../TransactionUtility/connected-table-style-utility-bar";

function SpreadAndMarginAccordion(props) {
  const compBids = parseInt(props.transactions.compBids, 10);

  return (
    <TableContainer variant="outlined">
      <Table
        striped
        sx={{ minWidth: 650 }}
        aria-label="simple table"
        size={"small"}
      >
        <TableStyleUtility />
        <TableBody>
          {props.paymentType.paymentType === LEASE.title && (
            <TableRow
              hover
              key="Calculated Lease Price"
              id={"calculated Lease Price"}
            >
              <TableCell>
                <InputLabel> {props.texts.LEASED_PRICE}</InputLabel>
              </TableCell>
              <TableCell align="center">
                <Input
                  type={"text"}
                  fullWidth
                  id="jdCalcLeasePrice"
                  value={props.transactions.bids[0].calcLeasePrice}
                />
              </TableCell>
              {Array(compBids)
                .fill(null)
                .map((value, index) => (
                  <TableCell align="center">
                    <Input
                      type={"text"}
                      fullWidth
                      id="compCalcLeasePrice"
                      value={props.transactions.bids[index + 1].calcLeasePrice}
                    />
                  </TableCell>
                ))}
            </TableRow>
          )}

          <TableRow
            hover
            key="Calculated Adjust Machine Price"
            id={"Calculated Adjust Machine Price"}
          >
            <TableCell>
              <InputLabel>{props.texts.ADJUSTED_MACHINE_PRICE}</InputLabel>
            </TableCell>
            <TableCell align="center">
              <Input
                type={"text"}
                fullWidth
                id="jdCalcAdjustMacPrice"
                value={props.transactions.bids[0].calcAdjustMacPrice}
              />
            </TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center">
                  <Input
                    type={"text"}
                    fullWidth
                    id="compCalcAdjustMacPrice"
                    value={
                      props.transactions.bids[index + 1].calcAdjustMacPrice
                    }
                  />
                </TableCell>
              ))}
          </TableRow>

          <TableRow
            hover
            key="Calculated Normalize TP"
            id={"Calculated Normalize TP"}
          >
            <TableCell>
              <InputLabel>{props.texts.NORMALIZED_TRANS_PRICE}</InputLabel>
            </TableCell>
            <TableCell align="center">
              <Input
                type={"text"}
                fullWidth
                id="jdCalcNormalizeTp"
                value={props.transactions.bids[0].calcNormalizeTp}
              />
            </TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center">
                  <Input
                    type={"text"}
                    fullWidth
                    id="compCalcNormalizeTp"
                    value={props.transactions.bids[index + 1].calcNormalizeTp}
                  />
                </TableCell>
              ))}
          </TableRow>

          <TableRow
            hover
            key="Calculated Machine Spread"
            id={"Calculated Machine Spread"}
          >
            <TableCell>
              <InputLabel>{props.texts.SPREAD_ON_MACHINE}</InputLabel>
            </TableCell>
            <TableCell align="center"></TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center">
                  <Input
                    type={"text"}
                    fullWidth
                    id="compCalcMachSpread"
                    value={props.transactions.bids[index + 1].calcMachSpread}
                  />
                </TableCell>
              ))}
          </TableRow>

          <TableRow
            hover
            key="Calculated Program Spread"
            id={"Calculated Program Spread"}
          >
            <TableCell>
              <InputLabel>{props.texts.SPREAD_PROG}</InputLabel>
            </TableCell>
            <TableCell align="center"></TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center">
                  <Input
                    type={"text"}
                    fullWidth
                    id="compCalcProgSpread"
                    value={props.transactions.bids[index + 1].calcProgSpread}
                  />
                </TableCell>
              ))}
          </TableRow>

          <TableRow
            hover
            key="Calculated Final Spread"
            id={"Calculated Final Spread"}
          >
            <TableCell>
              <InputLabel>{props.texts.FINAL_SPREAD}</InputLabel>
            </TableCell>
            <TableCell align="center"></TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center">
                  <Input
                    type={"text"}
                    fullWidth
                    id="compCalcFinalSpread"
                    value={props.transactions.bids[index + 1].calcFinalSpread}
                  />
                </TableCell>
              ))}
          </TableRow>

          <TableRow
            hover
            key="Calculated Final Spread Pct"
            id={"Calculated Final Spread Pct"}
          >
            <TableCell>
              <InputLabel>{props.texts.FINAL_SPREAD_PERCENT}</InputLabel>
            </TableCell>
            <TableCell align="center"></TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center">
                  <Input
                    type={"text"}
                    fullWidth
                    id="compCalcFinalSpreadPct"
                    value={
                      props.transactions.bids[index + 1].calcFinalSpreadPct
                    }
                  />
                </TableCell>
              ))}
          </TableRow>

          <TableRow
            hover
            key="calculated Gross Margin"
            id={"calculated Gross Margin"}
          >
            <TableCell>
              <InputLabel>{props.texts.GROSS_MARGIN}</InputLabel>
            </TableCell>
            <TableCell align="center">
              <Input
                type={"text"}
                fullWidth
                id="jdCalcGrossMargin"
                value={props.transactions.bids[0].calcGrossMargin}
              />
            </TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center"></TableCell>
              ))}
          </TableRow>

          <TableRow
            hover
            key="calculated Gross Margin Pct"
            id={"calculated Gross Margin Pct"}
          >
            <TableCell>
              <InputLabel>{props.texts.GROSS_MARGIN} %</InputLabel>
            </TableCell>
            <TableCell align="center">
              <Input
                type={"text"}
                fullWidth
                id="jdCalcGrossMarginPct"
                value={props.transactions.bids[0].calcGrossMarginPct}
              />
            </TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center"></TableCell>
              ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SpreadAndMarginAccordion;
